<template>
  <div class="container-fluid h-100">
    <div class="content_section_products" id="content-club" title="">
      <div
        class="row jusify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100 ">
        <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
          <div class="banner_superior"></div>
          <h1 class="title_landing">
            Protección insuperable para cada motor
          </h1>

          <!-- Sección de carrusel de imágenes -->
          <div id="carouselExampleControls" class="carousel slide" data-ride="carousel" data-interval="false">
            <div class="carousel-inner">
              <div v-for="(chunk, chunkIndex) in chunkedImages" :key="chunkIndex" :class="chunkIndex === 0 ? 'carousel-item active' : 'carousel-item'">
                <div class="content_carousel">
                  <div v-for="(prod, prodIndex) in chunk" :key="prodIndex" class="carousel_imgs_products">
                    <div class="img_carousel">
                      <a @click="scrollToProduct(prod.id)">
                        <img class="d-block w-100" :src="prod.image" :alt="prod.name"/>
                      </a>
                    </div>
                    <span class="product_name_carousel">{{ prod.name }}</span>
                  </div>
                </div>
              </div>
            </div>

            <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
              <span class="fa-solid fa-chevron-left"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
              <span class="fa-solid fa-chevron-right"></span>
              <span class="sr-only">Next</span>
            </a>
          </div><br>

          <!-- Sección de productos -->
          <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
            <h2 class="title_atributos">Atributos y Beneficios de Productos Havoline.</h2>
          </div>
          <div 
            v-for="item in products" :key="item.id" 
            class="content_product col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12" 
            :id="item.id" 
            :class="{ 'selected_product': item.selected }"
          >
            <div class="content_img col-12 col-lg-2">
              <img :src="item.image" alt="imagen de producto"/>
            </div>
            <div class="content_desc_product col-12 col-md-10 col-lg-10 col-xl-10 col-sm-10">
              <div class="col-12 col-lg-2" :class="class_img">
                <img :src="item.image" alt="imagen de producto"/>
              </div>
              <div class="title_product">
                {{ item.name }}
              </div>
              <div class="subtitle_product">
                {{ item.sub_title }}
              </div>
              <div class="desc_product">
                {{ item.description }}
              </div>
              <div class="btn_more">
                <a :href="item.link" target="_blank">
                  <button class="know_more">
                    CONOCE MÁS
                  </button>
                </a>
              </div>
            </div>
          </div>  

          <!-- Sección banner y filtro de distribuidores -->
          <div class="banner_background">
            <div class="title_distributor">
              <h1>DISTRIBUIDORES</h1>
            </div>
            <div class="filter col-10 col-md-6 col-lg-6 col-xl-6 col-sm-10">
              <span>CONOCE NUESTROS DISTRIBUIDORES</span>

              <select
                @change="getDistributorsByDepartment($event)"
                class="select_department"
              >
                <option style="color:black !important;" disabled selected value="null">SELECCIONAR DEPARTAMENTO</option>
                <option 
                  v-for="department in listDepartments"
                  :value="department"
                  :key="department"
                >
                  {{ department }}
                </option>
              </select>

              <select
                v-if="listDistributors.length > 0"
                @change="changeDistributor($event)"
                class="select_dictributor"
              >
                <option style="color:black !important;" disabled selected value="null">SELECCIONAR DISTRIBUIDOR</option>
                <option 
                  v-for="distributor in listDistributors"
                  :value="distributor.id"
                  :key="distributor.id"
                >
                  {{ distributor.name }}
                </option>
              </select>
            </div>
          </div>

          <!-- Sección de distribuidores -->
          <div v-if="objetcDistributor" class="section_distributor col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
            <div class="section_phone col-12 col-md-6 col-lg-6 col-xl-6 col-sm-6">
              <img alt="Información del distribuidor" class="col-12 col-lg-6" :src="imageInfo" />
            </div>
            <div class="section_info_distributor col-12 col-md-6 col-lg-6 col-xl-6 col-sm-6">
              <div class="img_distributor col-12 col-md-2 col-lg-2 col-xl-2 col-sm-2">
                <img alt="distribuidor" :src="objetcDistributor.image" />
              </div>
              <div class="info_distributor col-12 col-md-6 col-lg-6 col-xl-6 col-sm-6">
                <div class="name_distributor">
                  {{ objetcDistributor.name }}
                  <div class="red_line_1"></div>
                  <div class="red_line_2"></div>
                </div>
                
                <div class="address_distributor">
                  <span>Dirección:&nbsp;</span>{{ objetcDistributor.address }}
                </div>
                <div class="cellphone_distributor">
                  <span>Cel:&nbsp;</span>{{ objetcDistributor.cellphone }}
                </div>
                <div class="phone_distributor">
                  <span>Tel:&nbsp;</span>{{ objetcDistributor.phone }}
                </div>
                <div class="button_web">
                  <a :href="objetcDistributor.link" target="_blank">
                    <button>
                      <span class="fa-solid fa-globe"></span>&nbsp;
                      WEB
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "sectionWebProduct",
  data() {
    return {
      products: [],
      listDepartments: [],
      listDistributors: [],
      objetcDistributor: null,
      imageInfo: null,
      class_img: 'img_product_mobile',
    };
  },
  computed: {
    chunkedImages() {
      const chunkSize = window.innerWidth < 768 ? 2 : 5;
      const chunks = [];
      for (let i = 0; i < this.products.length; i += chunkSize) {
        chunks.push(this.products.slice(i, i + chunkSize));
      }
      return chunks;
    }
  },
  methods: {
    scrollToProduct(productId) {
      const targetElement = document.getElementById(productId);
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'smooth'
        });
        this.products.forEach(product => {
          product.selected = product.id === productId;
        });
      }
    },
    getProducts(){
      this.products = [];
      axios
      .get("api/get/products")
      .then(res => {
        if (res.data.cod == 0) {
          this.products = res.data.data.map(element => {
            if(element.status_id == 1){
              return { ...element, selected: false };
            }
          });
          this.products.sort((a, b) => a.product_order - b.product_order);
        }
      })
      .catch(error => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
    getDepartments() {
      var departments = new Set();
      axios
        .get("api/get/departments")
        .then(res => {
          if (res.data.cod == 0) {
            res.data.data.forEach(element => {
              if (element.status_id == 1) {
                const departmentsArray = element.department.split(',').map(department => department.trim());
                departmentsArray.forEach(department => departments.add(department));
              }
            });
            this.listDepartments = Array.from(departments);
            this.listDepartments.sort();
          }
        })
        .catch(error => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    getDistributorsByDepartment(event){
      let department = event.target.value;
      this.listDistributors = [];
      axios
      .post("api/get/distributors/" + department)
      .then(res => {
        if (res.data.cod == 0) {
          res.data.data.forEach(element => {
            if(element.status_id == 1){
              this.listDistributors.push(element);
            }
          });
        }
      })
      .catch(error => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
    changeDistributor(event){
      let IdDistributor = event.target.value;
      this.objetcDistributor = this.listDistributors.find(j => j.id == IdDistributor);
      this.imageInfo = this.objetcDistributor.image_info;
    },
  },
  mounted(){
    this.getProducts();
    this.getDepartments();
  },
}
</script>

<style scoped>
.content_section_products {
  padding: 10% 0% 15% 0%;
  height: 100%;
  background-color: white !important;
}
.banner_superior{
  background-image: url('../../assets/img/banner_seccion_web_productos_desktop.jpg');
  background-size: cover;
  background-position: center;
  height: 60vh;
  margin: -50px 0px 50px 0px;
}
.title_landing {
  font-size: 50px;
  font-family: 'Gotham-UltraItalic', sans-serif;
  padding-bottom: 30px;
  color: #dc3545;
  margin: 70px auto 50px auto;
}
.content_carousel{
  display: flex;
  max-width: 85%;
  margin: auto;
}
.carousel_imgs_products{
  margin: 0px auto 0px auto;
  max-width: 200px;
}
.carousel_imgs_products > .img_carousel{
  background-color:#d9d9d9;
  margin: auto;
  border-radius: 10px;
  max-width: 200px;
  height: 200px;
  padding: 20px;
  cursor: pointer;
}
.product_name_carousel{
  color: black;
  font-family: 'Gotham-UltraItalic', sans-serif;
  font-size: 14px;
  padding: 10px auto auto auto;
}
.fa-chevron-left, .fa-chevron-right{
  color: black;
  margin: auto;
  background-color: #d9d9d9;
  border-radius: 50%;
  padding: 8px 10px 10px 10px;
  cursor: pointer;
  width: 30px;
  height: 32px;
}
.carousel-control-next, .carousel-control-prev {
  width: 4% !important;
}
/* .carousel-control-prev{
  left: -5%;
}
.carousel-control-next{
  right: -5%;
} */
.title_atributos{
  font-size: 22px;
  font-family: 'Gotham-UltraItalic', sans-serif;
  color: black;
  text-align: center;
  margin-top: 25px;
}
.selected_product {
  box-shadow: 0px 0px 20px black;
  transition: 3s;
}
.content_product{
  display: flex;
}
.content_img{
  margin: auto 5px auto 0px;
}
.content_img > img{
  background-color: #f5f5f5;
  padding: 10px;
  max-width: 200px;
  max-height: 200px;
}
.img_product_mobile{
  display: none;
}
.content_desc_product{
  background-color: #d9d9d9;
  padding: 10px;
  margin: auto;
  min-height: 200px;
}
.title_product, .subtitle_product, .desc_product, .btn_more{
  text-align: left;
}
.title_product{
  font-family: 'Gotham-UltraItalic', sans-serif;
  color: black;
}
.subtitle_product{
  font-family: 'GothamBoldItalic', sans-serif;
  color: black;
}
.desc_product{
  font-family: 'GothamBoldItalic', sans-serif;
  color: black;
}
.btn_more{
  max-width: 15%;
  background-color: #f50000;
  padding: 5px 20px 5px 20px;
  border-radius: 10px;
  text-align: center;
  font-family: 'Gotham-UltraItalic', sans-serif;
  color: white;
}
.know_more{
  color: white;
}
.banner_background{
  background-image: url('../../assets/img/fondo_comments.jpg');
  background-size: cover;
  height: 300px;
  position: relative;
  margin: 20px auto;
}
.title_distributor > h1{
  color: white;
  font-size: 50px;
  font-family: 'GothamBoldItalic', sans-serif;
  text-align: center;
  padding-top: 100px;
}
.filter{
  background-color: white;
  margin: auto;
  border-radius: 10px;
  border: 5px solid gray;
  padding: 30px 0px 30px 0px;
  position: absolute;
  top: 240px;
  left: 25%;
  right: 25%;
}
.filter > span{
  color: black;
  padding: 5px;
  margin-right: 10px;
  font-family: 'GothamBoldItalic', sans-serif;
}
.select_dictributor{
  border: 2px solid gray;
  padding: 10px 20px;
  border-radius: 5px;
  font-family: 'GothamBoldItalic', sans-serif;
  cursor: pointer;
  margin: 5px;
  font-size: 14px;
}
.select_dictributor > option{
  color: #dc3545 !important;
}
.select_department{
  border: 2px solid gray;
  padding: 10px 20px;
  border-radius: 5px;
  font-family: 'GothamBoldItalic', sans-serif;
  cursor: pointer;
  margin: 5px;
  font-size: 14px;
}
.select_department > option{
  color: #dc3545 !important;
}
.icon_select{
  color: black;
  background-color: #d9d9d9;
  padding: 5px;
  border-radius: 100%;
  cursor: pointer;
  margin-left: -35px;
}
.section_distributor{
  margin-top: 200px;
  display: flex;
}
.section_phone > img{
  min-width: 500px;
  height: 750px;
}
.section_info_distributor{
  display: flex;
}
.img_distributor{
  margin: 0px 0px auto 0px;
}
.img_distributor > img{
  width: 100px;
}
.name_distributor, .address_distributor, .cellphone_distributor, .phone_distributor{
  text-align: left;
  color: black;
  font-family: 'GothamBoldItalic', sans-serif;
  padding: 5px 2px;
}
.name_distributor{
  font-size: 22px;
}
.address_distributor, .cellphone_distributor, .phone_distributor{
  font-size: 15px;
}
.red_line_1{
  max-width: 60%;
  background-color: #f50000;
  height: 8px;
  margin: auto auto auto 0px;
}
.red_line_2{
  max-width: 60%;
  background-color: #f50000;
  height: 5px;
  margin: 3px auto auto 0px;
}
.button_web > a > button{
  border-radius: 5px;
  background-color: #f50000;
  padding: 2px 15px 2px 15px;
  float: left;
  color: white;
}

@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* MOBILE */
@media (max-width: 767px) {
  .content_section_products{
    padding-top: 35% !important;
    padding-bottom: 35% !important;
  }
  .banner_superior{
    background-image: url('../../assets/img/banner_seccion_web_productos_tablet.jpg');
    background-size: cover;
    background-position: center;
    height: 60vh;
    margin: -150px 0px 50px 0px;
  }
  .title_landing {
    font-size: 32px;
  }
  .carousel_imgs_products > .img_carousel{
    height: auto !important;
    max-width: 120px;
    padding: 15px;
  }
  .title_atributos{
    font-size: 18px;
  }
  .content_product{
    display: block;
  }
  .content_img{
    display: none;
  }
  .img_product_mobile{
    display: block !important;
  }
  .img_product_mobile > img{
    display: block !important;
    margin: auto;
    max-width: 100px;
    max-height: 100px;
  }
  .btn_more{
    min-width: 100% !important;
  }
  .title_distributor > h1{
    font-size: 32px;
  }
  .select_dictributor{
    padding: 10px 20px 10px 20px;
  }
  .icon_select{
    display: none;
  }
  .filter{
    top: 200px;
    margin: auto;
    left: 10%;
    right: 10%;
  }
  .section_distributor{
    margin-top: 150px;
    display: flex;
    flex-flow: column;
  }
  .section_info_distributor{
    display: block;
    order: -1;
  }
  .name_distributor, .address_distributor, .cellphone_distributor, .phone_distributor{
    text-align: center;
  }
  .button_web, .red_line_1, .red_line_2{
    margin: 3px auto;
    float: none;
  }
  .button_web > a > button{
    float: none;
  }
  .section_phone > img{
    min-width: auto;
    height: auto;
  }
}

@media (max-width: 520px) {
  .banner_superior{
    background-image: url('../../assets/img/banner_seccion_web_productos_movil.jpg');
    background-size: cover; 
    background-position: center bottom;
    height: 60vh;
    margin: -60px 0px 50px 0px;
  }
}
</style>